import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '@/lib/utils';

export type FieldLegendProps = ComponentPropsWithoutRef<'legend'> & {
  variant?: 'legend' | 'label';
};

const FieldLegend = ({ className, variant = 'legend', ...props }: FieldLegendProps) => {
  return (
    <legend
      data-slot="field-legend"
      data-variant={variant}
      className={cn(
        'mb-1.5 text-xl leading-6 font-medium tracking-[-0.5px]',
        'data-[variant=label]:text-base data-[variant=label]:leading-5 data-[variant=label]:font-semibold data-[variant=label]:tracking-[-0.03em] data-[variant=label]:select-none',
        className,
      )}
      {...props}
    />
  );
};

export default FieldLegend;
